import './App.css';
import './sass/styles.scss';
import TapsHeader from './components/tapsHeader';
import StepsComponent from './context/StepsContext';
import ComponentLoader from './components/componentLoader';
import { Footer, GtmService } from '@iq-solutions/nida-shared';
import { container } from 'tsyringe';

function App(): JSX.Element {
  const gtm = container.resolve(GtmService);
  gtm.init();

  return (
    <div className="App">
      <TapsHeader />
      <StepsComponent>
        <ComponentLoader></ComponentLoader>
      </StepsComponent>
      <Footer />
    </div>
  );
}

export default App;
